import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { ExamTemplate } from '../exam-template/exam-template';

const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
    providedIn: 'root'
})
export class ExamTemplateService {

  private examTemplateUrl = 'api/exam_templates';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) {}

  get(id: number): Observable<ExamTemplate> {
    return this.http
      .get<ExamTemplate>(`${this.examTemplateUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  searchByName(name: string): Observable<ExamTemplate[]> {
    if (!name.trim()) { return of([]); }
    return this.http
      .get<ExamTemplate[]>(`${this.examTemplateUrl}/?name=${name}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  create(template: ExamTemplate): Observable<ExamTemplate> {
    return this.http
      .post<ExamTemplate>(this.examTemplateUrl, template, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  update(template: ExamTemplate): Observable<ExamTemplate> {
    return this.http
      .patch<ExamTemplate>(`${this.examTemplateUrl}/${template.id}`, template, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  delete(id: number): Observable<ExamTemplate> {
    return this.http
      .delete(`${this.examTemplateUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}